// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f84227de","451":"8f68566c","453":"c3d6c4b0","467":"6f9e3c2f","905":"a4bbd277"}[chunkId] + ".chunk.js";
};